const SHORT_ID_FORMAT = /^[a-zA-z0-9]+$/;
const isShortId = (value) => {
    return !!value && SHORT_ID_FORMAT.test(value);
};

export { isShortId };
